import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosConfig';

// Müşteri bilgisi değişiklik geçmişi (v1.12.0) — her değişen alan ayrı satır, aynı kayıt anı gruplanır.

interface Degisiklik {
  degisiklikID: number;
  degisiklikTarihi: string;
  alan: string;
  eskiDeger?: string | null;
  yeniDeger?: string | null;
  kullanici?: string | null;
}

interface Props {
  cariID: number;
  onClose: () => void;
}

const CariDegisiklikGecmisi: React.FC<Props> = ({ cariID, onClose }) => {
  const [liste, setListe] = useState<Degisiklik[]>([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(false);

  useEffect(() => {
    axiosInstance.get(`/api/Cariler/${cariID}/degisiklikler`)
      .then(res => setListe(res.data || []))
      .catch(() => setHata(true))
      .finally(() => setYukleniyor(false));
  }, [cariID]);

  // Aynı kullanıcı + aynı kayıt anı = tek düzenleme
  const gruplar: { anahtar: string; tarih: string; kullanici?: string | null; satirlar: Degisiklik[] }[] = [];
  liste.forEach(d => {
    const anahtar = `${d.degisiklikTarihi}|${d.kullanici}`;
    const son = gruplar[gruplar.length - 1];
    if (son && son.anahtar === anahtar) son.satirlar.push(d);
    else gruplar.push({ anahtar, tarih: d.degisiklikTarihi, kullanici: d.kullanici, satirlar: [d] });
  });

  const deger = (v?: string | null) => v ? v : <span style={{ color: '#cbd5e1' }}>(boş)</span>;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(15,23,42,0.5)' }} />
      <div onClick={e => e.stopPropagation()}
        style={{ position: 'relative', width: '96%', maxWidth: 720, maxHeight: '88vh', background: '#f8fafc', borderRadius: 16, display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 24px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ padding: '16px 22px', background: '#fff', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontSize: 16.5, fontWeight: 700, color: '#1a2440' }}>
            <i className="fas fa-clock-rotate-left" style={{ color: '#cd6906', marginRight: 8 }}></i>Bilgi Değişiklik Geçmişi
          </div>
          <button type="button" onClick={onClose} style={{ width: 32, height: 32, border: 'none', borderRadius: '50%', background: '#f1f5f9', color: '#475569', cursor: 'pointer', fontSize: 17 }}>×</button>
        </div>
        <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
          {yukleniyor ? (
            <div style={{ textAlign: 'center', color: '#94a3b8', padding: 30 }}><i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>Yükleniyor...</div>
          ) : hata ? (
            <div style={{ textAlign: 'center', color: '#b91c1c', padding: 30 }}>Geçmiş yüklenemedi.</div>
          ) : gruplar.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#94a3b8', padding: 30 }}>Kayıtlı değişiklik yok.</div>
          ) : gruplar.map(g => (
            <div key={g.anahtar} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
              <div style={{ padding: '9px 14px', background: '#f8fafc', borderBottom: '1px solid #e5e7eb', fontSize: 12.5, color: '#475569', display: 'flex', justifyContent: 'space-between' }}>
                <span><i className="fas fa-user" style={{ marginRight: 6, color: '#94a3b8' }}></i><strong>{g.kullanici || 'Bilinmiyor'}</strong></span>
                <span>{new Date(g.tarih).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' })}</span>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <tbody>
                  {g.satirlar.map(d => (
                    <tr key={d.degisiklikID}>
                      <td style={{ padding: '7px 14px', fontWeight: 600, color: '#334155', width: 130, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>{d.alan}</td>
                      <td style={{ padding: '7px 14px', color: '#64748b', textDecoration: 'line-through', verticalAlign: 'top', borderBottom: '1px solid #f1f5f9', wordBreak: 'break-word' }}>{deger(d.eskiDeger)}</td>
                      <td style={{ padding: '7px 4px', color: '#94a3b8', verticalAlign: 'top', borderBottom: '1px solid #f1f5f9' }}>→</td>
                      <td style={{ padding: '7px 14px', color: '#0f172a', fontWeight: 600, verticalAlign: 'top', borderBottom: '1px solid #f1f5f9', wordBreak: 'break-word' }}>{deger(d.yeniDeger)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CariDegisiklikGecmisi;
